import { useToast } from '@chakra-ui/react'; // Chakra UI components
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const ToastContainer = React.memo(() => {
   
    const toast = useToast();
    const { message } = useSelector((state) => state.ui);
    useEffect(() => {
        if (message) {
            toast(message);
        }
    }, [message, toast]);

    return(<></>);
})

export default ToastContainer;
